export const FLOA_MIN_AMOUNT = 50;
export const FLOA_MAX_AMOUNT = 6000;
export const FLOA_PAY_TYPES = ['3XG', '4XG'];
